module.exports = __webpack_public_path__ + "img/104.3d49b7fc.webp";